import { ReactNode } from 'react';

import { cn } from '../../../libs/utils';

/*
 *  description, additionalInfo, topNavigation, stickyBottom을 조합해 Page를 만듭니다.
 * */

interface InfoViewProps {
  description: ReactNode;
  additionalInfo?: ReactNode;
  stickyBottom?: ReactNode;
  className?: string;
}

/*
 * Description, AdditionalInfo 을 조합해 Page를 만듭니다.
 * */
export const InfoView = ({ description, additionalInfo, stickyBottom, className, ...props }: InfoViewProps) => {
  return (
    <div
      className={cn(
        'container-padding-medium container-medium w-full mx-auto flex flex-col items-center justify-center py-spacious-medium',
        {
          'pb-[142px]': stickyBottom
        },
        className
      )}
      {...props}
    >
      {description}
      {additionalInfo}
      {stickyBottom}
    </div>
  );
};
